import api from "../axios";

class BaseService {
    api = api;
}

export default BaseService;
